export default class InputGetTasks
{
  constructor(pageNumber, resultsNumber, status, searchText, orderBy) 
  {
    this.pageNumber = pageNumber;
    this.resultsNumber = resultsNumber;
    this.status = status;
    this.searchText = searchText;
    this.orderBy = orderBy;
  }    
}